module.exports = __webpack_public_path__ + "img/tbz.fc774156.png";